import React from 'react';
import { MousePointerClick } from 'lucide-react';
import { ETAPAS } from './SubscribersTable';

const PARTNER_COLORS = {
  'Orange Travel Assist': 'from-orange-500 to-yellow-400',
  'Mercantil Travel': 'from-indigo-500 to-purple-400',
  'Runaway Travel Assistance': 'from-emerald-500 to-teal-400',
  'World Medic Assist': 'from-sky-500 to-blue-400',
  'WhatsApp': 'from-[#25D366] to-[#128C7E]',
  'Compartir WhatsApp': 'from-slate-400 to-slate-300',
  'Compartir Facebook': 'from-slate-400 to-slate-300',
  'Compartir Instagram': 'from-slate-400 to-slate-300',
};
const LABELS = { 'WhatsApp': 'Botón WhatsApp', 'Chat IA': 'Asistente IA abierto', 'Compartir WhatsApp': 'Compartido por WhatsApp', 'Compartir Facebook': 'Compartido en Facebook', 'Compartir Instagram': 'Enlace copiado (Instagram)' };

export const InsightsPanel = ({ clicks, byEtapa }) => {
  const maxClicks = Math.max(1, ...(clicks?.data || []).map((c) => c.total));
  const totalLeads = Object.values(byEtapa || {}).reduce((a, b) => a + b, 0);

  return (
    <section className="grid lg:grid-cols-2 gap-6" data-testid="admin-insights">
      <div className="bg-white/5 border border-white/10 rounded-3xl p-6" data-testid="admin-partner-clicks">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg font-semibold">Clics por aliado, WhatsApp y compartidos</h2>
            <p className="text-slate-400 text-sm">Veces que pulsaron "Cotizar ahora", el botón de WhatsApp o compartieron la página</p>
          </div>
          <div className="flex items-center gap-2 text-2xl font-bold" data-testid="admin-clicks-total">
            <MousePointerClick className="h-5 w-5 text-blue-400" />
            {clicks ? clicks.total : '—'}
          </div>
        </div>
        <div className="space-y-4">
          {(clicks?.data || []).map((c) => (
            <div key={c.partner} data-testid={`admin-click-row-${c.partner.replace(/\s+/g, '-').toLowerCase()}`}>
              <div className="flex justify-between text-sm mb-1.5">
                <span className="font-medium">{LABELS[c.partner] || c.partner}</span>
                <span className="text-slate-400">
                  <span className="text-white font-semibold">{c.total}</span> total · {c.last_7_days} esta semana
                </span>
              </div>
              <div className="h-2.5 rounded-full bg-white/10 overflow-hidden">
                <div
                  className={`h-full rounded-full bg-gradient-to-r ${PARTNER_COLORS[c.partner] || 'from-blue-500 to-blue-400'} transition-[width] duration-700`}
                  style={{ width: `${(c.total / maxClicks) * 100}%` }}
                ></div>
              </div>
            </div>
          ))}
          {!clicks && <p className="text-slate-500 text-sm">Cargando...</p>}
        </div>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-3xl p-6" data-testid="admin-funnel">
        <h2 className="text-lg font-semibold">Embudo de seguimiento</h2>
        <p className="text-slate-400 text-sm mb-6">Leads activos por etapa</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {ETAPAS.map((e) => {
            const count = byEtapa?.[e.value] ?? 0;
            const pct = totalLeads ? Math.round((count / totalLeads) * 100) : 0;
            return (
              <div key={e.value} data-testid={`admin-funnel-${e.value}`} className={`rounded-2xl border p-4 ${e.className}`}>
                <p className="text-3xl font-bold text-white leading-none">{count}</p>
                <p className="text-xs uppercase tracking-wider mt-2 font-semibold">{e.label}</p>
                <p className="text-xs opacity-70 mt-1">{pct}%</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default InsightsPanel;
